import { getDeliveryErrorInfo } from "../lib/deliveryErrors";

interface DeliveryErrorActionsProps {
  /** The server's error `code`; nothing renders for non-delivery codes. */
  code: string | null | undefined;
  /** Whether the vehicle has assigned locations to go back to. */
  hasLocations: boolean;
  onChoosePickup: () => void;
  onChooseLocation: () => void;
}

/**
 * One-click way out of a delivery refusal: back to pickup, or back to the
 * list of the vehicle's delivery locations.
 */
export function DeliveryErrorActions({
  code,
  hasLocations,
  onChoosePickup,
  onChooseLocation,
}: DeliveryErrorActionsProps) {
  const info = getDeliveryErrorInfo(code);
  if (!info) return null;

  const toLocations = info.recovery === "locations" && hasLocations;

  return (
    <div className="mt-3">
      <button
        type="button"
        onClick={toLocations ? onChooseLocation : onChoosePickup}
        className="text-sm font-medium underline underline-offset-2"
      >
        {toLocations ? "Choose a delivery location" : "Switch to pickup"}
      </button>
    </div>
  );
}
